import RedesignImage from '../../shared/components/RedesignImage';
import { homepageImages } from '../assets';
import { useHomePageSharedStyles } from '../HomePage.styles';
import { UseHomePageReturn } from '../hooks/useHomePage';
import locale from '../locale.json';
import { useHomePageUniversSectionStyles } from './HomePageUniversSection.styles';

type HomePageUniversSectionProps = {
  onNavigate: UseHomePageReturn['redirect'];
};

const UNIVERS_ITEMS: {
  key: string;
  title: string;
  description: string;
  image: string;
  icon: string;
  tabIndex: number;
}[] = [
  {
    key: 'talents',
    title: 'Talents',
    description: 'Révélez vos compétences et valorisez votre potentiel.',
    image: homepageImages.univers.talents,
    icon: homepageImages.universIcons.talents,
    tabIndex: 1,
  },
  {
    key: 'carrieres',
    title: 'Carrières',
    description: 'Boostez votre évolution professionnelle.',
    image: homepageImages.univers.carrieres,
    icon: homepageImages.universIcons.carrieres,
    tabIndex: 4,
  },
  {
    key: 'sante',
    title: 'Santé',
    description: ' Préservez votre santé et votre équilibre.',
    image: homepageImages.univers.sante,
    icon: homepageImages.universIcons.sante,
    tabIndex: 3,
  },
  {
    key: 'education',
    title: 'Éducation',
    description: 'Développez vos compétences et expertises.',
    image: homepageImages.univers.education,
    icon: homepageImages.universIcons.education,
    tabIndex: 3,
  },
  {
    key: 'vie-perso',
    title: 'Vie perso',
    description: 'Cultivez votre épanouissement personnel.',
    image: homepageImages.univers.viePerso,
    icon: homepageImages.universIcons.viePerso,
    tabIndex: 3,
  },
];

const HomePageUniversSection = ({ onNavigate }: HomePageUniversSectionProps) => {
  const shared = useHomePageSharedStyles();
  const local = useHomePageUniversSectionStyles();
  const classes = { ...shared, ...local };

  return (
    <section className={classes.sectionWhite}>
      <div className={classes.sectionIntro}>
        <p className={classes.sectionLabel}>{locale.universLabel}</p>
        <h2 className={classes.sectionTitle}>{locale.universTitle}</h2>
        <p className={classes.sectionDescription}>{locale.universDescription}</p>
      </div>

      <div className={classes.universGrid}>
        {UNIVERS_ITEMS.map(item => (
          <button
            key={item.key}
            type="button"
            className={classes.universCard}
            onClick={() => onNavigate(item.tabIndex)}>
            <RedesignImage src={item.image} alt={item.title} className={classes.universImage} />
            <div className={classes.universWhiteOverlay} aria-hidden="true" />
            <div className={classes.universOverlay} aria-hidden="true" />
            <div className={classes.universContent}>
              <RedesignImage
                src={item.icon}
                alt=""
                className={classes.universIcon}
                aria-hidden="true"
              />
              <h3 className={classes.universCardTitle}>{item.title}</h3>
              <p className={classes.universCardDescription}>{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default HomePageUniversSection;
